import React, { useEffect, useRef } from 'react';
import { Box } from '@mui/material';
import useAnalytics from '../analytics/useAnalytics';
import { EVT_LIBRARY_LEAD_VIEW } from '../analytics/events';
import useLibraries from './hooks/useLibraries';
import ScrollProgressBar from './components/ScrollProgressBar';
import MarketingHeader from './sections/MarketingHeader';
import HeroSection from './sections/HeroSection';
import SocialProofStrip from './sections/SocialProofStrip';
import ProblemsSection from './sections/ProblemsSection';
import BenefitsSection from './sections/BenefitsSection';
import FeaturesSection from './sections/FeaturesSection';
import HowItWorksSection from './sections/HowItWorksSection';
import PricingSection from './sections/PricingSection';
import WebsiteAddonSection from './sections/WebsiteAddonSection';
import FeaturedLibrariesSection from './sections/FeaturedLibrariesSection';
import FaqSection from './sections/FaqSection';
import SignupSection from './sections/SignupSection';
import MarketingFooter from './sections/MarketingFooter';

function JoinUsAsLibrary() {
  const { track } = useAnalytics();
  const tracked = useRef(false);

  const { totalCount, uniqueCities, totalSeats, topLibraries, websiteLibraries, loading } = useLibraries();

  useEffect(() => {
    document.title = 'Join BookMyLibrary — List your library';
    if (!tracked.current) {
      tracked.current = true;
      track(EVT_LIBRARY_LEAD_VIEW);
    }
  }, [track]);

  return (
    <Box sx={{ bgcolor: 'background.default', minHeight: '100vh' }}>
      <ScrollProgressBar />
      <MarketingHeader />
      <HeroSection totalCount={totalCount} />
      <SocialProofStrip
        totalCount={totalCount}
        uniqueCities={uniqueCities}
        totalSeats={totalSeats}
        loading={loading}
      />
      <ProblemsSection />
      <BenefitsSection />
      <FeaturesSection />
      <HowItWorksSection />
      <PricingSection />
      <WebsiteAddonSection libraries={websiteLibraries} loading={loading} />
      <FeaturedLibrariesSection libraries={topLibraries} loading={loading} />
      <FaqSection />
      <SignupSection />
      <MarketingFooter />
    </Box>
  );
}

export default JoinUsAsLibrary;
